import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  ApiBuilder,
  AppConfigService,
  AppTokenService,
  AuthAccessTokenDetails,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods,
  UserDataService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  AppAuthTokenService,
  CommonConstants
} from '@com-delta-idp/mnx-skymiles-shared';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { AddToCart, AddToCartRequest, PurchaseResponse } from '../../models';
import { EndpointKeys, IDP_APPS } from '../../models/sky-club.constants';
@Injectable({
  providedIn: 'root'
})
export class PurchaseService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private appToken: AppTokenService,
    private userData: UserDataService,
    private authToken: AppAuthTokenService
  ) {}

  getPurchaseOptions = (): Observable<PurchaseResponse> => {
    return this.authToken.getToken().pipe(
      concatMap((token: AuthAccessTokenDetails) => {
        const commonHeaderInfo: HttpHeadersPayload = {};
        commonHeaderInfo['Authorization'] = 'Bearer ' + token.access_token;

        return new ApiBuilder<undefined, PurchaseResponse>(
          this.http,
          this.appConfig
        )
          .app(IDP_APPS.SKYCLUB)
          .endpointKey(EndpointKeys['PURCHASE_REQUEST_URL'])
          .httpHeaders(commonHeaderInfo)
          .method(HttpRequestMethods['GET_HEADERS'])
          .timeOut(CommonConstants.TIMEOUT)
          .errorHandler(this.errorHandler)
          .library(IDP_APPS.SKYCLUB)
          .create();
      })
    );
  };

  addToCart = (request: AddToCartRequest): Observable<AddToCart> => {
    return this.authToken.getToken().pipe(
      concatMap((token: AuthAccessTokenDetails) => {
        const commonHeaderInfo: HttpHeadersPayload = {};
        commonHeaderInfo['Authorization'] = 'Bearer ' + token.access_token;

        return new ApiBuilder<AddToCartRequest, AddToCart>(
          this.http,
          this.appConfig
        )
          .app(IDP_APPS.SKYCLUB)
          .endpointKey(EndpointKeys['ADD_TO_CART'])
          .httpHeaders(commonHeaderInfo)
          .payload(request)
          .method(HttpRequestMethods['POST'])
          .timeOut(CommonConstants.TIMEOUT)
          .errorHandler(this.errorHandler)
          .library(IDP_APPS.SKYCLUB)
          .create();
      })
    );
  };
}
